import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { guestApi } from '../../utils/portalApi';
import Avatar from '../Avatar';

/**
 * "New message" for a guest: everyone they can message one-to-one, which is
 * the people in the groups they are in (the server decides - see
 * GET /api/portal/people). Picking someone opens the existing chat with them,
 * or makes it.
 *
 * Drawn in place of the chat list, the way the staff messenger's people tab is.
 */
const GuestNewChat = ({ onClose, onOpened }) => {
    const navigate = useNavigate();
    const [people, setPeople] = useState(null);
    const [query, setQuery] = useState('');
    const [opening, setOpening] = useState(null);
    const [error, setError] = useState('');

    useEffect(() => {
        guestApi.get('/people')
            .then(({ data }) => setPeople(data))
            .catch((err) => { setPeople([]); setError(err.response?.data?.message || 'Could not load people.'); });
    }, []);

    const open = async (person) => {
        if (person.conversationId) {
            onClose();
            navigate(`/guest/chats/${person.conversationId}`);
            return;
        }
        setOpening(person._id);
        setError('');
        try {
            const { data } = await guestApi.post('/direct', { userId: person._id });
            onOpened?.();
            onClose();
            navigate(`/guest/chats/${data.conversationId}`);
        } catch (err) {
            setError(err.response?.data?.message || 'Could not open that chat.');
        } finally {
            setOpening(null);
        }
    };

    const term = query.trim().toLowerCase();
    const shown = (people || []).filter((p) => !term || p.name.toLowerCase().includes(term));

    return (
        <>
            <div className="msgr-sidebar-head">
                <div className="msgr-sidebar-title guest-newchat-title">
                    <button type="button" className="msgr-icon-btn" aria-label="Back to chats" onClick={onClose}>
                        <FontAwesomeIcon icon={faArrowLeft} />
                    </button>
                    <h3>New message</h3>
                </div>
                <div className="msgr-search">
                    <FontAwesomeIcon icon={faMagnifyingGlass} className="msgr-search-icon" />
                    <input autoFocus value={query} placeholder="Search people in your groups" onChange={(e) => setQuery(e.target.value)} />
                </div>
            </div>
            <div className="msgr-list">
                {people === null && <div className="msgr-empty">Loading…</div>}
                {error && <div className="msgr-empty">{error}</div>}
                {people && !people.length && !error && (
                    <div className="msgr-empty">Once you are in a group, you can message the people in it here.</div>
                )}
                {people && people.length > 0 && !shown.length && <div className="msgr-empty">Nobody matches that.</div>}
                {shown.map((p) => (
                    <div key={p._id} className="msgr-row" onClick={() => opening || open(p)}>
                        <Avatar name={p.name} profilePic={p.profilePic} className="msgr-avatar" />
                        <div className="msgr-row-body">
                            <div className="msgr-row-top"><span className="msgr-row-name">{p.name}</span></div>
                            <div className="msgr-row-bottom">
                                <span className="msgr-row-preview">
                                    {opening === p._id ? 'Opening…' : `In ${p.groups.slice(0, 2).join(', ')}${p.groups.length > 2 ? ` +${p.groups.length - 2}` : ''}`}
                                </span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
};

export default GuestNewChat;
